import { render, staticRenderFns } from "./FeedbackTab.vue?vue&type=template&id=6375867c&scoped=true"
import script from "./FeedbackTab.vue?vue&type=script&lang=js"
export * from "./FeedbackTab.vue?vue&type=script&lang=js"
import style0 from "./FeedbackTab.vue?vue&type=style&index=0&id=6375867c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6375867c",
  null
  
)

export default component.exports